import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let statuses = useDataValue({
    context: 'statuses',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.selected.statuses =
        statuses.length === next.selected.statuses.length
          ? []
          : statuses.map(status => status.id)
    })
  }
}

export function toggleSelectText(a, b) {
  return a === b ? 'Unselect All' : 'Select All'
}
